<div class="boxed collections">
  <div class="sticky">
    <div class="margin-b-2">
      <app-search-filter class="show-for-m"></app-search-filter>
    </div>
  </div>

  <app-products-grid>
    <div class="grid grid-gap-big collection-header margin-b-3">
      <div class="xs-12 m-6 collection-description">
        <div class="flex flex-row justify-between">
          <div>
            <small class="product-count"
              >{{ productNumber }}
              {{ "collection-detail.products" | i18next }}</small
            >
            <h1>{{ collection.texts.title | i18next }}</h1>
          </div>
        </div>
        <p>{{ collection.texts.description | i18next }}</p>
      </div>
      <div class="xs-12 m-1 collection-to-bag-button">
        <button (click)="addCollectionToBagPressed()">
          <svg
            version="1.1"
            id="Ebene_1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            width="31.5"
            height="35.2"
            viewBox="0 0 31.5 35.2"
            style="enable-background: new 0 0 31.5 35.2"
            xml:space="preserve"
          >
            <style type="text/css">
              .st0 {
                clip-path: url(#SVGID_00000003784471064110138160000011479747991331590330_);
              }
              .st1 {
                fill: #9c9c9c;
              }
            </style>
            <g id="Gruppe_385" transform="translate(0 0)">
              <g>
                <defs>
                  <rect id="SVGID_1_" y="0" width="31.5" height="35.2" />
                </defs>
                <clipPath
                  id="SVGID_00000123436585047846833560000013247672139194028954_"
                >
                  <use xlink:href="#SVGID_1_" style="overflow: visible" />
                </clipPath>
                <g
                  id="Gruppe_384"
                  style="
                    clip-path: url(#SVGID_00000123436585047846833560000013247672139194028954_);
                  "
                >
                  <path
                    id="Pfad_316"
                    class="st1"
                    d="M25.3,35.2H6.2C2.8,35.2,0,32.5,0,29c0-0.3,0-0.6,0.1-0.9L3,8.2C3.2,7,4.2,6.1,5.4,6.1H26
             c1.2,0,2.2,0.9,2.4,2.1l2.9,19.9c0.5,3.4-1.8,6.5-5.2,7C25.9,35.2,25.6,35.2,25.3,35.2 M5.4,7.1C4.7,7.1,4.1,7.6,4,8.3L1.1,28.3
             C1,28.5,1,28.8,1,29c0,2.9,2.3,5.2,5.2,5.2h19.1c0.3,0,0.5,0,0.8-0.1c2.8-0.4,4.8-3.1,4.4-5.9L27.5,8.3c-0.1-0.7-0.7-1.2-1.4-1.2
             L5.4,7.1z"
                  />
                  <path
                    id="Pfad_317"
                    class="st1"
                    d="M7.4,6.7c0-3.7,3-6.7,6.7-6.7v0l0,0c3.7,0,6.7,3,6.7,6.7h-1c0-3.1-2.6-5.7-5.7-5.7l0,0
             c-3.1,0-5.7,2.6-5.7,5.7H7.4z"
                  />
                  <path
                    id="Pfad_318"
                    class="st1"
                    d="M10.4,11.5h-1V6.7c0-3.7,3-6.7,6.7-6.7l0,0c3.7,0,6.7,3,6.7,6.7v4.8h-1V6.7
             c0-3.1-2.6-5.7-5.7-5.7l0,0c-3.1,0-5.7,2.6-5.7,5.7L10.4,11.5z"
                  />
                  <path
                    id="Pfad_319"
                    class="st1"
                    d="M9.9,12.5c-0.6,0-1-0.5-1-1c0-0.6,0.5-1,1-1c0.6,0,1,0.5,1,1c0,0,0,0,0,0
             C10.9,12.1,10.4,12.5,9.9,12.5 M9.9,11.5C9.9,11.5,9.9,11.5,9.9,11.5C9.9,11.5,9.9,11.5,9.9,11.5L9.9,11.5z"
                  />
                  <path
                    id="Pfad_320"
                    class="st1"
                    d="M22.3,12.5c-0.6,0-1-0.5-1-1c0-0.6,0.5-1,1-1s1,0.5,1,1c0,0,0,0,0,0
             C23.3,12.1,22.8,12.5,22.3,12.5 M22.3,11.5C22.3,11.5,22.3,11.5,22.3,11.5L22.3,11.5z"
                  />
                </g>
                <g id="Gruppe_384">
                  huh
                  <path
                    class="st1"
                    d="m5.27,29.34c-.44.54-.96.93-1.51.93s-.81-.33-.81-.9c0-.69.4-1.35.94-1.88.28-.28.79-.61,1.24-.61.28,0,.5.16.5.35,0,.22-.18.41-.42.41-.29,0-.33-.4-.52-.4-.51,0-.91,1.29-.91,2.05,0,.48.11.6.31.6.33,0,.8-.37,1.07-.7l.12.14Z"
                  />
                  <path
                    class="st1"
                    d="m5.7,29.04c0-1.06.85-2.23,1.96-2.23.83,0,1.07.7,1.07,1.21,0,.93-.72,2.26-1.93,2.26-.64,0-1.1-.42-1.1-1.24Zm1.22,1.04c.7,0,1.03-1.65,1.03-2.34,0-.5-.17-.73-.44-.73-.71,0-1.05,1.64-1.05,2.3,0,.33.06.76.45.76Z"
                  />
                  <path
                    class="st1"
                    d="m9.76,29.45c-.03.1-.08.27.01.27.11,0,.45-.47.45-.47l.15.13-.08.11c-.28.41-.57.79-.98.79-.29,0-.39-.16-.39-.39,0-.1.02-.22.06-.34l1.18-4.15c.04-.15-.02-.19-.2-.23l-.11-.03.02-.12c.45-.08.79-.16,1.18-.28l.06.12-1.34,4.59Z"
                  />
                  <path
                    class="st1"
                    d="m11.53,29.45c-.03.1-.08.27.01.27.11,0,.45-.47.45-.47l.15.13-.08.11c-.28.41-.57.79-.98.79-.29,0-.39-.16-.39-.39,0-.1.02-.22.06-.34l1.17-4.15c.04-.15-.02-.19-.2-.23l-.11-.03.02-.12c.45-.08.79-.16,1.18-.28l.06.12-1.35,4.59Z"
                  />
                  <path
                    class="st1"
                    d="m14.82,29.39c-.51.59-1.01.89-1.48.89-.54,0-.81-.31-.81-.9,0-1.19,1.06-2.57,2.06-2.57.45,0,.65.21.65.51,0,.86-1.27,1.28-1.82,1.39-.04.23-.07.45-.07.66,0,.32.08.53.31.53s.54-.14,1.04-.65l.12.13Zm-.48-2.38c-.28,0-.72.76-.88,1.52.59-.21,1.02-.68,1.02-1.28,0-.14-.05-.23-.13-.23Z"
                  />
                  <path
                    class="st1"
                    d="m17.53,29.34c-.44.54-.96.93-1.51.93s-.81-.33-.81-.9c0-.69.4-1.35.94-1.88.28-.28.79-.61,1.24-.61.28,0,.5.16.5.35,0,.22-.18.41-.42.41-.29,0-.33-.4-.52-.4-.51,0-.91,1.29-.91,2.05,0,.48.11.6.31.6.33,0,.8-.37,1.07-.7l.12.14Z"
                  />
                  <path
                    class="st1"
                    d="m19.02,26.37l.62-.3h.2l-.25.92h.68l-.11.26h-.64l-.62,2.16c-.04.13-.08.31.02.31.11,0,.28-.18.45-.39l.08-.09.16.13-.08.11c-.1.14-.59.79-1.07.79-.29,0-.4-.14-.4-.38,0-.1.02-.21.06-.34l.67-2.31h-.55l.02-.09.14-.17h.48l.17-.62Z"
                  />
                  <path
                    class="st1"
                    d="m21.59,27.91l-.47,1.54c-.02.06-.04.16-.04.2s0,.07.06.07c.13,0,.45-.48.45-.48l.15.13-.08.12c-.28.4-.57.79-.98.79-.13,0-.39-.05-.39-.39,0-.09.02-.2.06-.33l.54-1.82c.03-.09.07-.23.07-.31,0-.05-.02-.08-.06-.08-.13,0-.43.42-.48.49l-.15-.11.15-.21c.31-.42.59-.71.96-.71.27,0,.35.18.35.39,0,.13-.06.42-.14.71Zm.08-2.63c.27,0,.47.21.47.47,0,.31-.23.54-.52.54-.27,0-.47-.21-.47-.47,0-.28.21-.54.52-.54Z"
                  />
                  <path
                    class="st1"
                    d="m22.18,29.04c0-1.06.85-2.23,1.96-2.23.83,0,1.07.7,1.07,1.21,0,.93-.72,2.26-1.93,2.26-.64,0-1.1-.42-1.1-1.24Zm1.22,1.04c.7,0,1.03-1.65,1.03-2.34,0-.5-.17-.73-.44-.73-.71,0-1.05,1.64-1.05,2.3,0,.33.06.76.45.76Z"
                  />
                  <path
                    class="st1"
                    d="m25.57,27.72l.14-.2c.3-.43.59-.71.96-.71.26,0,.35.18.35.39,0,.32-.2.83-.2.83.58-1.03,1.09-1.22,1.39-1.22s.43.18.43.43c0,.1-.03.22-.06.33l-.53,1.88c-.04.13-.08.27.01.27.12,0,.45-.47.45-.47l.15.13-.08.11c-.28.4-.57.79-.98.79-.29,0-.38-.19-.38-.4,0-.11.02-.22.05-.32l.56-1.91s.06-.19.06-.26-.02-.13-.11-.13c-.33,0-1.08,1.24-1.25,1.82l-.33,1.06s-.36.07-.62.15l-.13-.12.74-2.51c.02-.08.05-.16.05-.23,0-.05-.02-.08-.06-.08-.13,0-.43.42-.48.49l-.14-.13Z"
                  />
                </g>
              </g>
            </g>
          </svg>
        </button>
      </div>
      <div class="xs-12 m-5 collection-image text-center">
        <img
          *ngIf="!collection.images.collection_mood"
          loading="lazy"
          src="{{ collection.images.collection | image }}"
        />
        <img
          *ngIf="collection.images.collection_mood"
          loading="lazy"
          src="{{ collection.images.collection_mood | image }}"
        />
      </div>
    </div>
  </app-products-grid>
</div>
<div class="collection-bar">
  <div class="sticky bottom">
    <div class="boxed experience">
      <div class="grid align-center align-spaced">
        <div
          [routerLink]="['/collections']"
          class="back xs-6 m-8 flex-container align-center align-left last-el pointer"
        >
          <div class="shrink margin-r-1">
            <svg
              height="5.759"
              viewBox="0 0 12.342 5.759"
              width="12.342"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
            >
              <defs>
                <clipPath id="clip-path">
                  <rect
                    data-name="Rechteck 118"
                    height="5.759"
                    id="Rechteck_118"
                    transform="translate(0 0)"
                    width="12.342"
                  />
                </clipPath>
              </defs>
              <g
                data-name="Gruppe 337"
                id="Gruppe_337"
                transform="translate(0 0)"
              >
                <g
                  clip-path="url(#clip-path)"
                  data-name="Gruppe 336"
                  id="Gruppe_336"
                >
                  <path
                    d="M11.931,2.468H3.3V.429a.427.427,0,0,0-.729-.3L.125,2.577a.428.428,0,0,0,0,.605L2.567,5.633a.427.427,0,0,0,.729-.3V3.291h8.635a.412.412,0,0,0,0-.823"
                    data-name="Pfad 161"
                    id="Pfad_161"
                  />
                </g>
              </g>
            </svg>
          </div>
          <div class="shrink">
            <span class="show-for-m">{{
              "collection-detail.back-to-collections" | i18next
            }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
